import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static get targets () {
    return ['dropdown', 'button']
  }

  initialize () {
    this.open = false
  }

  connect () {
    document.addEventListener('click', evt => {
      if (this.open) {
        let targetElement = evt.target // clicked element

        do {
          if (targetElement === this.element) {
            // This is a click inside. Do nothing, just return.
            return
          }
          // Go up the DOM
          targetElement = targetElement.parentNode
        } while (targetElement)
        // Get to document node without finding this element, close menu
        this.toggle()
      }
    })
  }

  toggle () {
    this.open = !this.open
    this.dropdownTarget.classList.toggle('show')
    this.buttonTarget.classList.toggle('is-rotated')
  }
}
